import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const LogoutRoute = () => {
    const { handleLogout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await handleLogout();
                navigate('/logout-success');
            } catch (error) {
                console.error('Logout error:', error);
                navigate('/');
            }
        };
        
        performLogout();
    }, [handleLogout, navigate]);

    return null;
};

export default LogoutRoute;